import Dynamic from 'next/dynamic';

import SkeletonWidget from 'components/SkeletonWidget';

export const AbroadLeadPersonalData = Dynamic(
  () =>
    import(
      'components/AbroadComponentsV2/SharedComponents/LeadForm/AbroadLeadPersonalData'
    ),
  { ssr: false, loading: () => <SkeletonWidget /> }
);

export const PremiumPlanRedeem = Dynamic(
  () =>
    import(
      'components/AbroadComponentsV2/SharedComponents/LeadForm/PremiumPlanRedeem'
    ),
  { ssr: false, loading: () => <SkeletonWidget /> }
);

export const AbroadLeadPlanning = Dynamic(
  () =>
    import(
      'components/AbroadComponentsV2/SharedComponents/LeadForm/AbroadLeadPlanning'
    ),
  { ssr: true }
);

export const MeetingFormComponent = Dynamic(
  () =>
    import(
      'components/AbroadComponentsV2/SharedComponents/LeadForm/MeetingForm'
    ),
  { ssr: true }
);

export const MessageUnlockComponent = Dynamic(
  () =>
    import(
      'components/AbroadComponentsV2/SharedComponents/LeadForm/MessageUnlockAbroad'
    ),
  { ssr: true }
);
